import { Component, Prop } from 'vue-property-decorator'

import { Mixins } from 'vue-mixin-decorator'
import MixinInterface from '@/_mixins/index'
import AttachmentMixin from '@/_mixins/attachment'

import { FileTypes } from '@/types/file-types'

@Component({
    mixins: [AttachmentMixin],
    inheritAttrs: false,
})
export default class Attachment extends Mixins<MixinInterface>(AttachmentMixin) {
    @Prop({ required: true }) attachment!: any

    get fileId() {
        return this.attachment?.attributes?.fileId
    }

    get preview() {
        return this.fileId ? this.getPreview(this.fileId) : null
    }

    get filename() {
        return this.attachment?.attributes?.filename
    }

    error = false

    get fileType() {
        return this.filename ? FileTypes[this.filename.split('.').slice(-1)[0]] : null
    }

    handleError() {
        this.error = true
    }
}
